<template>
  <nav class="navbar app-navbar navbar-toggleable-md">
    <div class="navbar-brand-container d-flex align-items-center justify-content-start" v-if="$mq === 'laptop' || $mq === 'desktop'">
      <router-link class="navbar-brand" to="/">
        <h1>
          <i :class="logoClass"></i>
        </h1>
      </router-link>
    </div>

    <div class="row navbar-container">

      <!-- <div class="menu-icon-container d-flex align-items-center justify-content-center justify-content-lg-start col" v-if="flow">
        <a class="menu-icon i-menu-expanded" href="#" @click.prevent="toggleSidebar(false)" v-if="sidebarOpened"></a>
        <a class="menu-icon i-menu-collapsed" href="#" @click.prevent="toggleSidebar(true)" v-else></a>
      </div> -->

      <div class="offset-md-3 col-md-1 nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-if="access !== 'User' && ($mq === 'desktop' || $mq === 'laptop')">
        <router-link :to="{ name: 'Tree' }" v-if="Policy.Fonenumber.can('index')">
          FoneTree
        </router-link>
      </div>
      <div class="col-md-1 nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-if="access !== 'User' && ($mq === 'desktop' || $mq === 'laptop')">
        <router-link :to="{ name: 'Users' }" v-if="Policy.User.can('index')">
          Users
        </router-link>
      </div>
      <div class="col-md-1 d-none d-lg-flex align-items-center justify-content-center" v-if="access !== 'User' && ($mq === 'desktop' || $mq === 'laptop')">
        <object-selector :variant="'features'"></object-selector>
      </div>
      <div class="col-md-1 d-none d-lg-flex align-items-center justify-content-center" v-if="access !== 'User' && ($mq === 'desktop' || $mq === 'laptop')">
        <object-selector :variant="'resources'"></object-selector>
      </div>
      <div class="offset-md-3 col-md-4 d-none d-lg-flex align-items-center justify-content-center" v-else-if="access === 'User' && ($mq === 'desktop' || $mq === 'laptop')">
        <object-selector :variant="'resources'"></object-selector>
      </div>
      <div class="offset-md-1 col-md-1 nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-if="$mq === 'desktop' || $mq === 'laptop'">
        <account-selector></account-selector>
      </div>

      <div class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-if="$mq === 'tablet'">
        <router-link class="navbar-brand" to="/">
          <h1>
            <i :class="logoClass"></i>
          </h1>
        </router-link>
      </div>
      <div class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-if="$mq === 'tablet'">
        <i class="mdi mdi-deskphone fractelfone" @click="openFracTELfone" aria-hidden="true"></i>
      </div>
      <div class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-if="$mq === 'tablet' || $mq === 'mobile'">
        <object-selector></object-selector>
      </div>
      <div class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-if="$mq === 'tablet' || $mq === 'mobile'">
        <account-selector></account-selector>
      </div>
      <div class="col-md-1 nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-if="$mq === 'desktop' || $mq === 'laptop'">
        <div class="col-md-6">
          <i class="mdi mdi-deskphone fractelfone" @click="openFracTELfone" aria-hidden="true"></i>
        </div>
        <div class="col-md-6">
          <i class="mdi mdi-help-circle-outline fractelfone" @click="openHelpdesk" aria-hidden="true"></i>
        </div>
      </div>
      <div class="col-md-1 nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-if="$mq === 'desktop' || $mq === 'laptop' || $mq === 'tablet'" v-dropdown>
        <a class="nav-link dropdown-toggle d-flex align-items-center justify-content" href="#"
           @click.prevent="closeMenu">
          <span class="avatar-container" v-if="avatar">
            <img :src="avatar"/>
          </span>
        </a>
        <div class="dropdown-menu last">
          <div class="dropdown-menu-content">
            <router-link :to="{ name: 'Profile' }" v-if="Policy.Profile.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.profile' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Logout' }">
              <div class="dropdown-item plain-link-item">
                {{'user.logout' | translate}}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="col-md-1 nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-if="$mq === 'desktop' || $mq === 'laptop' || $mq === 'tablet'" v-dropdown>
        <a class="nav-link dropdown-toggle d-flex align-items-center justify-content" href="#"
           @click.prevent="closeMenu">
          <span>
            <i class="fa fa-bars fa-lg"></i>
          </span>
        </a>
        <div class="dropdown-menu last">
          <div class="dropdown-menu-content">
            <router-link :to="{ name: 'Account' }" v-if="Policy.Account.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.account' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'SubAccounts' }" v-if="Policy.SubAccount.can('index') && parent === current && parent === billing">
              <div class="dropdown-item plain-link-item">
                {{'user.subaccounts' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'AccountSettings' }" v-if="Policy.Account.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.accountsettings' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'PortOrders' }" v-if="Policy.Fonenumber.can('buy')">
              <div class="dropdown-item plain-link-item">
                {{'user.portorders' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Billing' }" v-if="Policy.Billing.can('index') && parent === billing">
              <div class="dropdown-item plain-link-item">
                {{'user.billing' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Rates' }" v-if="Policy.Billing.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.rates' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'CDR' }" v-if="Policy.Analytics.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.cdr' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Recording' }" v-if="Policy.Analytics.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.recording' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'UserCDR' }" v-if="access === 'User'">
              <div class="dropdown-item plain-link-item">
                {{'user.cdr' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'UserRecording' }" v-if="access === 'User'">
              <div class="dropdown-item plain-link-item">
                {{'user.recording' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Stats' }" v-if="Policy.Analytics.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.stats' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'UserStats' }" v-if="access === 'User'">
              <div class="dropdown-item plain-link-item">
                {{'user.stats' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'MessagingBrands' }" v-if="Policy.MessagingBrand.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.messaging_brands' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Integrations' }" v-if="Policy.Billing.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.integrations' | translate}}
              </div>
            </router-link>
            <a href="https://developer.fonestorm.com" target="_blank">
              <div class="dropdown-item plain-link-item">
                FoneStorm API
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-else v-dropdown>
        <a class="nav-link dropdown-toggle d-flex align-items-center justify-content" href="#"
           @click.prevent="closeMenu">
          <span>
            <i class="fa fa-bars fa-lg"></i>
          </span>
        </a>
        <div class="dropdown-menu last">
          <div class="dropdown-menu-content">
            <router-link :to="{ name: 'Profile' }" v-if="Policy.Profile.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.profile' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Account' }" v-if="Policy.Account.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.account' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'AccountSettings' }" v-if="Policy.Account.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.accountsettings' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Billing' }" v-if="Policy.Billing.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.billing' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Rates' }" v-if="Policy.Billing.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.rates' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'PortOrders' }" v-if="Policy.Fonenumber.can('buy')">
              <div class="dropdown-item plain-link-item">
                {{'user.portorders' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'SubAccounts' }" v-if="Policy.SubAccount.can('index') && parent === current && parent === billing">
              <div class="dropdown-item plain-link-item">
                {{'user.subaccounts' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Users' }" v-if="Policy.User.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.users' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'CDR' }" v-if="Policy.Analytics.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.cdr' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Recording' }" v-if="Policy.Analytics.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.recording' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'UserCDR' }" v-if="access === 'User'">
              <div class="dropdown-item plain-link-item">
                {{'user.cdr' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'UserRecording' }" v-if="access === 'User'">
              <div class="dropdown-item plain-link-item">
                {{'user.recording' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Stats' }" v-if="Policy.Analytics.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.stats' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'UserStats' }" v-if="access === 'User'">
              <div class="dropdown-item plain-link-item">
                {{'user.stats' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'MessagingBrands' }" v-if="Policy.MessagingBrand.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.messaging_brands' | translate}}
              </div>
            </router-link>
            <router-link :to="{ name: 'Integrations' }" v-if="Policy.Billing.can('index')">
              <div class="dropdown-item plain-link-item">
                {{'user.integrations' | translate}}
              </div>
            </router-link>
            <div class="dropdown-item plain-link-item" @click="openFracTELfone">
              {{'user.fractelfone' | translate}}
            </div>
            <a href="https://developer.fonestorm.com" target="_blank">
              <div class="dropdown-item plain-link-item">
                FoneStorm API
              </div>
            </a>
            <a href="https://helpdesk.fractel.net/support/solutions" target="_blank">
              <div class="dropdown-item plain-link-item">
                Helpdesk
              </div>
            </a>
            <router-link :to="{ name: 'Logout' }">
              <div class="dropdown-item plain-link-item">
                {{'user.logout' | translate}}
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import AccountSelector from './AccountSelector'
  import ObjectSelector from './ObjectSelector'
  import Policy from '@/policy'
  import md5 from 'js-md5'
  import jwtDecode from 'jwt-decode'
  import ThemeService from '../../../services/ThemeService'

  export default {
    name: 'navbar',

    components: {
      AccountSelector,
      ObjectSelector
    },

    mounted: function () {
      var self = this
      const token = localStorage.getItem('fonestorm-token')
      const decoded = jwtDecode(token)
      self.access = decoded.authorization.access

      // Initialize current theme
      this.currentTheme = ThemeService.currentTheme

      // Listen for theme changes
      this.$root.$on('theme-changed', this.updateBranding)
    },

    beforeDestroy () {
      this.$root.$off('theme-changed', this.updateBranding)
    },

    data () {
      return {
        langs: [
          {
            code: 'gb',
            name: 'english'
          },
          {
            code: 'es',
            name: 'spanish'
          }
        ],
        flow: localStorage.getItem('flow-token'),
        token: localStorage.getItem('fonestorm-token'),
        // brandingLogo: localStorage.getItem('branding-logo'),
        // brandingColor: localStorage.getItem('branding-color'),
        brandingName: localStorage.getItem('branding-name') || 'FracTEL',
        currentTheme: 'fractel',
        Policy,
        parent: localStorage.getItem('fonestorm-parent-account'),
        username: localStorage.getItem('fonestorm-parent-username'),
        current: localStorage.getItem('fonestorm-account'),
        billing: localStorage.getItem('fonestorm-billing-account'),
        access: null
      }
    },

    computed: {
      ...mapGetters([
        'sidebarOpened',
        'toggleWithoutAnimation'
      ]),
      avatar () {
        return `https://www.gravatar.com/avatar/${md5(this.username)}?d=mp`
      },
      logoClass () {
        return `${this.currentTheme}-logo`
      }
    },

    methods: {
      ...mapActions([
        'closeMenu',
        'toggleSidebar',
        'isToggleWithoutAnimation'
      ]),
      openFracTELfone () {
        let userAgent = navigator.userAgent
        let isWChrome = false
        console.log(userAgent)
        if (userAgent.match(/Windows/i)) {
          if (userAgent.match(/Edge/i)) {
            console.log('Windows Edge Browser')
          } else {
            isWChrome = true
            console.log('Windows Chrome Browser')
          }
        }
        if (isWChrome) {
          window.open(`${process.env.FRACTELFONE_URL}login/${this.token}`, '', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=436, height=610')
        } else {
          window.open(`${process.env.FRACTELFONE_URL}login/${this.token}`, '', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=420, height=610')
        }
      },
      openHelpdesk () {
        window.open('https://helpdesk.fractel.net/support/solutions')
      },
      updateBranding () {
        this.currentTheme = ThemeService.currentTheme
        this.brandingName = localStorage.getItem('branding-name') || 'FracTEL'
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../sass/_variables.scss";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .navbar {
    .layout-fixed & {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 1;
    }
    .navbar-brand {
      .fractel-logo, .fonestorm-logo {
        position: relative;
        top: 5px;
        display: inline-block;
        height: 35px;
        margin-right: 10px;
        width: 120px;
      }

      h1 {
        position: relative;
        top: -5px;
        font-size: 28px;
        margin: 0;
      }
    }
  }

  .navbar.app-navbar {
    .navbar-container {
      width: 100%;
      height: 100%;
      margin: 0;
    }

    height: $top-nav-height;
    padding-left: $nav-padding-left;
    padding-right: $nav-padding-right;
    background-color: $top-nav-bg;

    .avatar-container {
      display: inline-block;
      width: 40px;
      height: 40px;
      background-color: white;
      border-radius: 50%;
      border: 2px solid $lighter-gray;
      overflow: hidden;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .menu-icon-container {
      padding: 0;
      font-size: $font-size-base;
    }

    .navbar-brand-container {
      position: absolute;
      z-index: 3;
      height: 100%;
      left: $navbar-brand-container-left;
      top: 0;
    }

    .nav-item {
      padding: 0;
      height: 100%;
    }

    .dropdown.navbar-dropdown {
      .dropdown-toggle {
        padding: 0;
        &:after {
          display: none;
        }
      }

      &.show {
        @include media-breakpoint-up(lg) {
          .dropdown-menu {
            left: auto;
            right: 0;
          }
        }
        &:after {
          position: absolute;
          bottom: -$dropdown-show-b;
          right: calc(50% - 10px);
          width: 0;
          height: 0;
          display: block;
          content: '';
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid var(--brand-primary, #{$fractel-teal});
        }
      }

      .dropdown-menu {
        margin-top: $dropdown-show-b;
        padding-top: 0;
        width: 100%;
      }

      .dropdown-item {
        line-height: 1.25;
        cursor: pointer;
        font-size: 6*$font-size-base/7;

        &:hover, &:active, &:focus, &.active {
          outline: none;
        }

        &.plain-link-item {
          color: $white;

          &:hover, &:active, &:focus {
            background-color: var(--brand-dark, #{$fractel-dark-teal});
          }

          .plain-link {
            text-decoration: none;
          }
        }
      }
    }

    .notify {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        right: -6px;
        top: -6px;
        background-color: $brand-primary;
        height: 12px;
        width: 12px;
        border-radius: 50%;
      }
    }

    .i-nav-notification.notify::after {
      right: -4px;
      top: 0;
    }

    @include media-breakpoint-down(md) {
      height: $top-mobile-nav-height;
      padding: $nav-mobile-pt $nav-mobile-padding-h $nav-mobile-pb $nav-mobile-padding-h;

      .navbar-brand-container {
        width: $nav-mobile-brand-width;
        top: $nav-mobile-brand-top;
        left: $nav-mobile-brand-left;
        height: auto;
        .navbar-brand {
          height: $font-size-smaller;
          padding: 0;
          font-size: $font-size-smaller;
        }
      }

      .dropdown.navbar-dropdown {
        &.show {
          display: flex;
          &:after {
            bottom: -$dropdown-mobile-show-b;
            z-index: 2;
          }
          .dropdown-menu {
            margin-top: $dropdown-mobile-show-b;
            left: auto;
            &.last {
              right: 0;
            }
          }
        }
      }
    }

    .fractelfone {
      color: var(--brand-primary, #{$fractel-teal});
      font-size: 1.6rem;

      &:hover {
        color: lighten($fractel-teal, 10%);
        cursor: pointer;
      }
    }

    .tree {
      color: var(--brand-primary, #{$fractel-teal});
      font-size: 1.6rem;

      &:hover {
        color: lighten($fractel-teal, 10%);
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/navbar/Navbar.vue